import {
  MonetateApiResponseAction,
  ParsedMonetateApiResponseActions,
} from 'redux/modules/experiments/actions/types';
import {
  MONETATE_DEFAULT_VARIANT,
  MONETATE_EXPERIMENT_TYPE,
  MONETATE_OMNICHANNEL_JSON_ACTION_TYPE,
} from 'constants/monetate';

export const parseMonetateResponse = (actions: MonetateApiResponseAction[]) => {
  return actions.reduce<ParsedMonetateApiResponseActions>(
    (parsedMonetateResponse, { actionType, isControl, impressionReporting, json }) => {
      if (
        actionType === MONETATE_OMNICHANNEL_JSON_ACTION_TYPE &&
        json?.type === MONETATE_EXPERIMENT_TYPE
      ) {
        const { id, variant, payload } = json;

        return {
          decisions: {
            ...parsedMonetateResponse.decisions,
            [id]: isControl ? MONETATE_DEFAULT_VARIANT : variant,
          },
          payloads: { ...parsedMonetateResponse.payloads, [id]: payload },
          impressions: { ...parsedMonetateResponse.impressions, [id]: impressionReporting[0] },
        };
      }

      return parsedMonetateResponse;
    },
    { decisions: {}, payloads: {}, impressions: {} },
  );
};
